const ALLOWED_FONT_HOSTNAME = 'fonts.bunny.net'

export interface ThemeFont {
  url: string
  family: string
}

/**
 * Strips the family name to characters safe inside a CSS font-family value.
 * e.g. "Evil';background:url(...)" -> "Evilbackground"
 */
function sanitizeFamily(fontFamilyParam: string): string {
  const [rawName = ''] = fontFamilyParam.split(':')
  return rawName.replace(/[^A-Za-z0-9 -]/g, '').trim()
}

export function parseThemeFontUrl(fontUrl: string | undefined): ThemeFont | null {
  if (!fontUrl) return null

  let parsed: URL
  try {
    parsed = new URL(fontUrl)
  } catch {
    return null
  }

  if (parsed.protocol !== 'https:') return null
  if (parsed.hostname !== ALLOWED_FONT_HOSTNAME) return null

  // Only the first `family` is read, so callers must pass single-family URLs (one family per
  // heading/body token). A multi-family URL (?family=A&family=B) would apply only family A.
  const fontFamilyParam = parsed.searchParams.get('family')
  if (!fontFamilyParam) return null

  const family = sanitizeFamily(fontFamilyParam)
  if (!family) return null

  return { url: parsed.href, family }
}
